import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { PaginatedResponse } from '@shared/types';
import type { NotificationItem } from '../types';

export function useNotifications() {
  const query = useQuery({
    queryKey: queryKeys.notifications,
    queryFn: () => apiClient.get<PaginatedResponse<NotificationItem>>('/notifications'),
    select: (data) => data.items,
  });

  const unreadCount = query.data?.filter((n) => !n.isRead).length ?? 0;

  return { ...query, unreadCount };
}
